import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle, ArrowRight, DeviceMobile, ChatCircle, Barbell } from "@phosphor-icons/react";

/**
 * /join/welcome — final funnel step. Registered, authed, on 7-day trial.
 * Any accepted OTOs are recorded via Stripe webhook against their user_id.
 */
export default function JoinWelcomePage() {
  const nav = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => nav("/app/onboarding"), 30000);
    return () => clearTimeout(t);
  }, [nav]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col">
      <div className="border-b border-[#262626] py-4 px-6 flex items-center justify-between">
        <div className="font-oswald text-2xl uppercase tracking-wider">
          Lazy<span className="text-[#FF3333]">Lean</span>
        </div>
        <div className="text-[10px] font-manrope uppercase tracking-[0.15em] text-[#00CC66]">
          ✓ You&apos;re in
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-2xl w-full text-center">
          <div className="w-20 h-20 mx-auto bg-[#FF3333] flex items-center justify-center mb-6">
            <CheckCircle size={44} weight="fill" className="text-white" />
          </div>

          <div className="id-label text-[#FF3333] mb-3">— WELCOME TO LAZY LEAN METHOD —</div>
          <h1 className="font-oswald text-4xl md:text-6xl font-bold uppercase tracking-tight leading-[0.95] mb-6">
            You&apos;re In.<br/>Let&apos;s Get You Lean.
          </h1>
          <p className="text-zinc-300 font-manrope text-lg mb-10 max-w-md mx-auto">
            Next step: a 60-second onboarding so Coach Jimmy can build your first plan tonight.
          </p>

          <button
            onClick={() => nav("/app/onboarding")}
            className="id-btn-primary px-10 py-5 text-base mx-auto"
            data-testid="welcome-onboarding-btn"
          >
            Start My Onboarding <ArrowRight size={16} weight="bold" />
          </button>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-xl mx-auto text-left">
            {[
              { icon: Barbell, title: "Custom plan", body: "Delivered in your dashboard within 24hrs." },
              { icon: ChatCircle, title: "Coach chat", body: "Message Jimmy anytime — he replies." },              { icon: DeviceMobile, title: "Install the app", body: "Add to your iPhone home screen for full access." },
            ].map((f, i) => (
              <div key={i} className="border border-[#262626] bg-[#0F0F0F] p-4">
                <f.icon size={20} weight="bold" className="text-[#FF3333] mb-2" />
                <div className="font-oswald uppercase text-sm tracking-wide mb-1">{f.title}</div>
                <div className="text-zinc-500 text-xs font-manrope leading-relaxed">{f.body}</div>
              </div>
            ))}
          </div>

          <div className="mt-10 text-xs text-zinc-500 font-manrope">
            Redirecting to onboarding in 30 seconds...
          </div>
        </div>
      </div>
    </div>
  );
}
